export default __webpack_public_path__ + "static/media/sort_down_deactive.61fa1636.svg";